module.exports = __webpack_public_path__ + "static/media/fig_13e.4895e3d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_13e.jpg
// module id = 640
// module chunks = 0